module.exports = __webpack_public_path__ + "static/camera_movement-88eb99738405d6ef2dd26070bc0018bc.gif";